import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MedicinePaginationDTO, PaginationDTO } from "../../dtos/manufacturer";
import { AddMedicineDTO, DeleteMedicineDTO } from "../../dtos/medicine";
import MedicineService from "./medicineService";

// Define initial state
const initialState = {
  medicineDetails: [],
  medicineId: "",
  isLoading: false,
  isSuccess: false,
  isError: false,
  message: <any>"",
  isMedicineLoading: false,
  isMedicineLoadingError: false,
};

export const AddMedicine = createAsyncThunk(
  "api/pharmacy/medicine/add",
  async (medicine: AddMedicineDTO, thunkAPI) => {
    try {
      return await MedicineService.AddMedicine(medicine);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const editMedicine = createAsyncThunk(
  "medicine/edit",
  async (medicine: AddMedicineDTO, thunkAPI) => {
    try {
      return await MedicineService.editMedicine(medicine);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);


export const deleteMedicine = createAsyncThunk(
  "pharmacy/medicine/delete",
  async (dto: DeleteMedicineDTO, thunkAPI) => {
    try {
      return await MedicineService.deleteMedicine(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getMedicineData = createAsyncThunk(
  "medicine/getMedicineData", 
  async ({ pharmacy_id, dto }: { pharmacy_id: any; dto?: MedicinePaginationDTO }, thunkAPI) => {
    try {
      const response = await MedicineService.getMedicine(pharmacy_id, dto); 
      return response.data; 
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAllMedicineData = createAsyncThunk(
  "medicine/getAllMedicineData", 
  async (_, thunkAPI) => {
    try {
      const response = await MedicineService.getAllMedicine(); 
      return response.data; 
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAllNonMedicineData = createAsyncThunk(
  "medicine/getAllNonMedicineData", 
  async (_, thunkAPI) => {
    try {
      const response = await MedicineService.getAllNonMedicine(); 
      return response.data; 
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const medicineSlice = createSlice({
  name: "medicineSlice",
  initialState,
  reducers: {
    reset: () => initialState,
    changeMedicineId: (state, action) => {
      state.medicineId = action.payload.resp;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getMedicineData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getMedicineData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.medicineDetails = action.payload.resp;
        state.message = "";
      })
      .addCase(getMedicineData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

// Export actions and reducer
export const { reset, changeMedicineId } = medicineSlice.actions;
export default medicineSlice.reducer;